import { useSuspenseQuery } from '@connectrpc/connect-query'
import { useTranslation } from 'react-i18next'

import { getPlan } from '~/gen/proto/bff/v1/common-BffCommonService_connectquery'
import { Plan } from '~/gen/proto/bff/v1/model_pb'

export function usePlan(planId: number): Plan {
  const { t } = useTranslation()
  const res = useSuspenseQuery(
    getPlan,
    { id: planId },
    {
      select: (data) => data.plan,
    },
  )
  if (res.isError || res.data === undefined) {
    throw new Error(t('message.fetchFail', { entity: t('domain.plan') }))
  }
  return res.data
}
